import { render } from "./days.vue?vue&type=template&id=79aa0310"
import script from "./days.vue?vue&type=script&lang=js"
export * from "./days.vue?vue&type=script&lang=js"
script.render = render

export default script